import { createSelector } from "@reduxjs/toolkit";

import { createNodeSelector, getNodeTypeIdSelector, nodeIdParamSelector, useNautilusSelector } from "../state/index.ts";

const initialConfigSelector = createSelector(
  [createNodeSelector, nodeIdParamSelector, getNodeTypeIdSelector],
  (createNode, nodeId, getNodeTypeId) => {
    const typeId = getNodeTypeId(nodeId);
    return createNode(typeId).config;
  },
);

export const useGetInitialConfig = <TConfig>(nodeId: number): TConfig =>
  useNautilusSelector((state): TConfig => initialConfigSelector(state, { nodeId }));
